// import React, { useContext, useEffect, useMemo, useState } from "react";
// import { PlusOutlined, MinusCircleOutlined, ArrowLeftOutlined, DeleteOutlined, UploadOutlined, FilePdfOutlined, FileWordOutlined, FileImageOutlined, FileUnknownOutlined } from "@ant-design/icons";
// import {
//   Col,
//   Row,
//   Form,
//   Input,
//   message,
//   Card,
//   Select,
//   DatePicker,
//   Button,
//   Modal,
//   Upload
// } from "antd";
// import { useNavigate } from "react-router-dom";
// import "dayjs/locale/en";
// import { BiSolidInbox, BiUpload } from "react-icons/bi";
// import { MdDeleteOutline } from "react-icons/md";
// import { AuthContext } from "../../Auth/AuthContext";
// import {
//   addProject,
//   getallDeveloperForTask,
//   getCustomers,
//   getQualifiedRawDataTitles,
// } from "../../utils/API";
// import { FaUpload } from "react-icons/fa";
// import { UploadChangeParam } from "antd/es/upload";
// import { UploadFile } from "antd/lib";
// import { RcFile } from "antd/lib/upload";
// const { Option } = Select;

// interface AddProjectModalProps {
//   visible: boolean;
//   onClose: () => void;
//   onTaskCreated: () => void;
//   isOpen?: boolean; // Make it optional if you still want to keep it
// }
// const AddProjectModal: React.FC<AddProjectModalProps> = ({ visible, onClose, onTaskCreated }) => {
// const CUSTOM_VALUE_PREFIX = "__custom__:";
// const CUSTOM_VALUE_PREFIX = "__custom__:";
//   const navigate = useNavigate();
//   const { authData } = useContext(AuthContext);
//   const [previewImage, setPreviewImage] = useState<string>("");
//   const [apiImageUploaded, setApiImageUploaded] = useState(false);
//   const [form] = Form.useForm(); // Use Form hook to get form instance
//   const [isLoading, setIsLoading] = React.useState(false);
//   const [clients, setClients] = useState<any>([]);
//   const user_id = authData.user._id;
//   const id = user_id.replace(/["']/g, "");
//   const imageUrl = process.env.REACT_APP_IMAGE_URL || "";
//   const roleId = authData.roleId;
//   const [Purposal, setPurposal] = useState<Array<string | File>>([]);
//   const [fileListPurposal, setFileListPurposal] = useState<any[]>([]);
//   const [Contract, setContract] = useState<(string | File)[]>([]);
//   const [fileListContract, setFileListContract] = useState<UploadFile<File>[]>([]);
//   const [developers, setDevelopers] = useState<{ _id: string; username: string }[]>([]);
//   const [qualifiedTitles, setQualifiedTitles] = useState<string[]>([]);
//   const [isTitlesLoading, setIsTitlesLoading] = useState(false);

//   const handleSubmit = async (values: any) => {
//     try {
//       setIsLoading(true);

//       const formData = new FormData();

//       // Append normal fields only if they have a value
//       Object.keys(values).forEach((key) => {
//         if (
//           key !== "purposal" &&
//           key !== "contract" &&
//           key !== "milestones" &&
//           values[key] !== undefined &&
//           values[key] !== null &&
//           values[key] !== ""
//         ) {
//           // Special case: budget → send as number if provided
//           if (key === "budget") {
//             formData.append("budget", String(Number(values.budget)));
//           }
//           // Special case: assignees → MUST send as array
//           else if (key === "assignees") {
//             const list = Array.isArray(values.assignees)
//               ? values.assignees
//               : String(values.assignees).split(",").map((id) => id.trim());

//             list.forEach((id: string | Blob) => formData.append("assignees[]", id));
//           }

//           else {
//             formData.append(key, values[key]);
//           }
//         }
//       });

//       // Append milestones as JSON string if exists
//       if (values.milestones && values.milestones.length > 0) {
//         formData.append("milestones", JSON.stringify(values.milestones));
//       }

//       // Append Purposal files from state
//       Purposal.forEach((file) => {
//         formData.append("purposal", file as RcFile);
//       });

//       // Append Contract files from state
//       Contract.forEach((file) => {
//         formData.append("contract", file as RcFile);
//       });

//       const parsedValues = { ...values };

// if (typeof parsedValues.clientId === "string" && parsedValues.clientId.startsWith(CUSTOM_VALUE_PREFIX)) {
//   formData.delete("clientId");
//   formData.append("clientName", parsedValues.clientId.replace(CUSTOM_VALUE_PREFIX, ""));
// }

// await addProject(formData);
//       message.success("Project added successfully!");
//       form.resetFields();
//       setPurposal([]);
//       setContract([]);
//       setFileListPurposal([]);
//       setFileListContract([]);
//       onTaskCreated();
//       setClientSearchText("");
//       onClose();
// //     } catch (error: any) {
//       message.error(error.message || "Failed to add project");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchDevelopers = async () => {
//       try {
//         const response: any = await getallDeveloperForTask("", "");
//         setDevelopers(response?.data || []);
//       } catch {
//         message.error("Failed to load developers");
//         setDevelopers([]);
//       }
//     };

//     fetchDevelopers();
//   }, []);

//   useEffect(() => {
//     const fetchClients = async () => {
//       try {
//         const response: any = await getCustomers("", "");

//         if (response?.data) {
//           // Filter only active clients
//           const activeClients = response.data.filter(
//             (client: any) => client.isActive === true
//           );
//           setClients(activeClients);
//         }
//       } catch (error) {
//         console.error("Error fetching clients:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchClients();
//   }, []);

//   useEffect(() => {
//     const fetchQualifiedTitles = async () => {
//       if (!visible) {
//         return;
//       }

//       try {
//         setIsTitlesLoading(true);
//         const response: any = await getQualifiedRawDataTitles();
//         setQualifiedTitles(Array.isArray(response?.data) ? response.data : []);
//       } catch (error) {
//         console.error("Error fetching qualified titles:", error);
//         setQualifiedTitles([]);
//       } finally {
//         setIsTitlesLoading(false);
//       }
//     };

//     fetchQualifiedTitles();
//   }, [visible]);

//   const getFileIcon = (fileName: string) => {
//     const ext = fileName.split(".").pop()?.toLowerCase();

//     if (ext === "pdf") return <FilePdfOutlined className="text-2xl text-red-500 mb-1" />;
//     if (ext === "doc" || ext === "docx") return <FileWordOutlined
//       className="text-2xl text-blue-500 mb-1" />;
//     if (ext === "jpg" || ext === "jpeg" || ext === "png")
//       return <FileImageOutlined className="text-2xl text-green-500 mb-1" />;

//     // default fallback
//     return <FileUnknownOutlined className="text-2xl text-gray-500 mb-1" />;
//   };
//   const handleDeletePurposal = (doc: string | File, index: number) => {
//     const newPurposal = [...Purposal];
//     newPurposal.splice(index, 1);
//     setPurposal(newPurposal);

//     const newFileListPurposal = [...fileListPurposal];
//     newFileListPurposal.splice(index, 1);
//     setFileListPurposal(newFileListPurposal);
//   };

//   const handleDeleteContract = (doc: string | File, index: number) => {
//     const newContract = [...Contract];
//     newContract.splice(index, 1);
//     setContract(newContract);

//     const newFileListContract = [...fileListContract];
//     newFileListContract.splice(index, 1);
//     setFileListContract(newFileListContract);
//   };

//   return (
//     <Modal

//       visible={visible}
//       onCancel={onClose}
//       footer={null}
//       width={700}
//       centered // Disable centered to use top positioning
//       destroyOnClose
//       className="custom-modal"
//       bodyStyle={{
//         overflowY: "auto",
//         fontFamily: "inter, sans-serif",
//       }}
//       styles={{
//         header: {
//           padding: "12px",
//           position: "sticky",
//           top: 0,
//           backgroundColor: "#f1f5ffff",
//         },
//         content: {
//           padding: 0,
//           overflow: "hidden",
//         },
//       }}
//       title={
//         <div
//           style={{
//             color: "#4b5563",
//             fontFamily: "inter, sans-serif",
//             fontSize: "20px",
//             fontWeight: 500,
//           }}
//         >
//           Create New Project
//         </div>
//       }
//     >
//       <Form
//         form={form}
//         layout="horizontal"
//         labelCol={{ span: 5 }}
//         wrapperCol={{ span: 19 }}
//         colon={false}
//         initialValues={{
//           budget: 0,
//         }}
//         onFinish={handleSubmit}
//       >
//         <div className="elements">
//           {/* name */}

//            <Form.Item
//                 label={
//                   <span style={{
//                     color: '#4b5563',
//                     fontFamily: 'inter, sans-serif',
//                     fontWeight: 500,
//                     paddingLeft: "15px",
//                   }}>
//                     Title
//                   </span>
//                 }
//               >
//                 <Select
//                   size="large"
//                   allowClear
//                   showSearch
//                   disabled={roleId == 2}
//                   loading={isTitlesLoading}
//                   placeholder="Select Title"
//                   className="CustomSelect"
//                   options={qualifiedTitles.map((title) => ({
//                     label: title,
//                     value: title,
//                   }))}
//                   onChange={(value) => {
//                     form.setFieldsValue({ projectName: value || "" });
//                   }}
//                   filterOption={(input, option) =>
//                     (option?.label ?? "")
//                       .toString()
//                       .toLowerCase()
//                       .includes(input.toLowerCase())
//                   }
//                 />
//               </Form.Item>

//               <Form.Item
//                 label={
//                   <span style={{
//                     color: '#4b5563',
//                     fontFamily: 'inter, sans-serif',
//                     fontWeight: 500,
//                     paddingLeft: "15px",
//                   }}>
//                     Project Name <span className="text-danger">*</span>
//                   </span>
//                 }
//                 name="projectName"
//                 required={false}
//                 rules={[{ required: true, message: "Please Enter Name" }]}
//               >
//                 <Input
//                   size="large"
//                   disabled={roleId == 2}
//                   className="Allinput"
//                   placeholder="Project Name"
//                 />
//               </Form.Item>

//           <Form.Item
//             label={<span style={{
//               color: '#4b5563',
//               fontFamily: 'inter, sans-serif',
//               fontWeight: 500,
//               paddingLeft: "15px",
//             }}>Client Name<span className="text-danger">*</span></span>}
//             name="clientId"
//             required={false}
//             rules={[{ required: true, message: "Please Select Client" }]}
//           >
//             <Select
//               size="large"

//               disabled={roleId === 2}
//               loading={isLoading}
//               placeholder="Select Client"
//               className="CustomSelect"
//             >
//               {clients.map((client: any) => (
//                 <Select.Option key={client._id} value={client._id}>
//                   {client.name}
//                 </Select.Option>
//               ))}
//             </Select>
//           </Form.Item>

//           <Form.Item
//             label={<span style={{
//               color: '#4b5563', // Medium gray color similar to the image
//               fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
//               fontSize: '14px', // Approximate font size based on the image
//               fontWeight: 500, // Medium weight to match "font-medium"
//               paddingLeft: "15px",
//             }}>Assignees</span>}
//             required={false}
//             name="assignees"

//             rules={[{ required: true, message: "Please select at least one assignee" }]}
//           >
//             <Select mode="multiple" placeholder="Select Assignees"
//               filterOption={(input, option) =>
//                 (option?.children ?? "")
//                   .toString()
//                   .toLowerCase()
//                   .includes(input.toLowerCase())
//               }>
//               {developers.map((dev) => (
//                 <Option key={dev._id} value={dev._id}>
//                   {dev.username}
//                 </Option>
//               ))}
//             </Select>
//           </Form.Item>

//           <Form.Item
//             label={<span style={{
//               color: '#4b5563',
//               fontFamily: 'inter, sans-serif',
//               fontWeight: 500,
//               paddingLeft: "15px",
//             }}>Start Date<span className="text-danger">*</span></span>}
//             name="startDate"
//             required={false}
//             rules={[{ required: true, message: "Please Select Start Date" }]}
//           >
//             <DatePicker
//               size="large"
//               disabled={roleId == 2}
//               format="DD-MM-YYYY"
//               placeholder="Select Start Date"
//               className="Allinput"
//             />
//           </Form.Item>

//           {/* Completion Date */}
//           <Form.Item
//             label={
//               <span style={{
//                 color: '#4b5563', // Medium gray color similar to the image
//                 fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
//                 fontSize: '14px', // Approximate font size based on the image
//                 fontWeight: 500, // Medium weight to match "font-medium"
//                 paddingLeft: "15px",
//               }}>
//                 Target Date <span className="text-danger">*</span>
//               </span>
//             }
//             required={false}
//             name="completionDate"
//             rules={[{ required: true, message: "Please Select Target Date" }]}
//           >
//             <DatePicker
//               size="large"
//               disabled={roleId == 2}
//               className="Allinput"
//               placeholder="Select Target Date"
//               format="DD-MM-YYYY"
//             />
//           </Form.Item>

//           {/* Ending Date */}

//           <Form.Item
//             label={
//               <span style={{
//                 color: '#4b5563', // Medium gray color similar to the image
//                 fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
//                 fontSize: '14px', // Approximate font size based on the image
//                 fontWeight: 500, // Medium weight to match "font-medium"
//                 paddingLeft: "15px",
//               }}>
//                 Complete Date
//               </span>
//             }
//             name="endingDate"
//             required={false}
//           >
//             <DatePicker
//               size="large"
//               disabled={roleId == 2}
//               className="Allinput"
//               placeholder="Select Complete Date"
//               format="DD-MM-YYYY"
//             />
//           </Form.Item>

//           {/* budget*/}

//           <Form.Item
//             label={<span style={{
//               color: '#4b5563',
//               fontFamily: 'inter, sans-serif',
//               fontWeight: 500,
//               paddingLeft: "15px",
//             }}>Budget</span>}
//             name="budget"
//             initialValue={0}
//           >
//             <Input
//               type="number"
//               size="large"
//               className="Allinput"
//               placeholder="Budget"
//             // defaultValue={0}
//             />
//           </Form.Item>

//           {/* Milestone */}
//           <Form.Item label={<span style={{
//             color: '#4b5563',
//             fontFamily: 'inter, sans-serif',
//             fontWeight: 500,
//             paddingLeft: "15px",
//           }}>Milestones</span>} colon={false}>
//             <Form.List name="milestones">
//               {(fields, { add, remove }) => (
//                 <div className="milestone-wrapper">
//                   {/* Add Milestone Button at the Top */}
//                   <Button
//                     type="dashed"
//                     onClick={() => add()}
//                     icon={<PlusOutlined />}
//                     className="w-100 mb-3"
//                   >
//                     Add Milestone
//                   </Button>

//                   {/* Milestone Cards - rendered in reverse order */}
//                   {fields.map(({ key, name, ...restField }, index) => (
//                     <div key={key} className="subtask-card" style={{ order: -index }}>
//                       <div className="row">
//                         {/* Milestone Date */}
//                         <div className="column">
//                           <Form.Item
//                             {...restField}
//                             name={[name, "date"]}
//                             rules={[{ required: true, message: "Please select a date" }]}
//                           >
//                             <DatePicker
//                               size="large"
//                               disabled={roleId == 2}
//                               className="subtask-input"
//                               format="DD-MM-YYYY"
//                               placeholder="Select Milestone Date"
//                             />
//                           </Form.Item>
//                         </div>

//                         {/* Milestone Comment */}
//                         <div className="column" style={{ flex: '0 0 50%', maxWidth: '50%' }}>
//                           <Form.Item
//                             {...restField}
//                             name={[name, "comment"]}
//                             rules={[{ required: true, message: "Please enter a comment" }]}
//                           >
//                             <Input
//                               size="large"
//                               disabled={roleId == 2}
//                               className="subtask-input"
//                               placeholder="Enter Milestone Comment"
//                             />
//                           </Form.Item>
//                         </div>
//                       </div>

//                       {/* Remove Button */}
//                       <div className="delete-btn-container">
//                         <Button
//                           danger
//                           type="text"
//                           icon={<DeleteOutlined />}
//                           onClick={() => remove(name)}
//                         />
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </Form.List>

//           </Form.Item>
//           <Col span={24}>
//             <Form.Item
//               label={<span style={{
//                 color: '#4b5563',
//                 fontFamily: 'inter, sans-serif',
//                 fontSize: '14px',
//                 paddingLeft: "15px",
//                 fontWeight: 500,
//               }}>Proposal</span>}
//               name="purposal"
//               valuePropName="fileList"
//               getValueFromEvent={(e) => e.fileList}
//             >
//               <div className="flex flex-col gap-3">
//                 <div
//                   className="grid grid-cols-[auto,1fr] gap-4 items-start"
//                 >
//                   <Upload
//                     action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
//                     listType="picture-card"
//                     // maxCount={1}
//                     showUploadList={false}
//                     // disabled={Purposal.length > 0} // Disable when file exists
//                     fileList={fileListPurposal}   // ✅ controlled by state

//                     onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
//                       const rawFiles = info.fileList
//                         .map((f) => f.originFileObj)
//                         .filter((f): f is RcFile => !!f);

//                       setPurposal(rawFiles);
//                       setFileListPurposal(info.fileList);
//                     }}
//                     beforeUpload={() => false}
//                   >
//                     <Button
//                       icon={<UploadOutlined />}
//                     // disabled={resumes.length > 0} // Visual disabled state
//                     >
//                       Upload
//                     </Button>
//                   </Upload>

//                   <div className="grid grid-cols-1 gap-3">
//                     {Purposal.map((doc, index) => {
//                       if (!doc) return null;

//                       const fileName =
//                         typeof doc === "string"
//                           ? doc.split("/").pop() || ""
//                           : (doc as File).name;

//                       const fileUrl =
//                         typeof doc === "string"
//                           ? `${imageUrl}${doc}`
//                           : URL.createObjectURL(doc as File);

//                       return (
//                         <div
//                           key={index}
//                           className="flex items-center justify-between border border-gray-200 rounded-lg p-2 bg-white shadow-sm"
//                         >
//                           <div className="flex items-center gap-2 overflow-hidden">
//                             {getFileIcon(fileName)}
//                             <a
//                               href={fileUrl}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="text-sm font-medium truncate max-w-[250px] hover:underline"
//                             >
//                               {fileName}
//                             </a>
//                           </div>
//                           <button
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               handleDeletePurposal(doc, index);

//                             }}
//                             className="text-red-500 hover:text-red-700"
//                           >
//                             <DeleteOutlined />
//                           </button>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             </Form.Item>
//           </Col>
//           <Col span={24}>
//             <Form.Item
//               label={
//                 <span
//                   style={{
//                     color: "#4b5563",
//                     fontFamily: "inter, sans-serif",
//                     fontSize: "14px",
//                     paddingLeft: "15px",
//                     fontWeight: 500,
//                   }}
//                 >
//                   NDA/Contract
//                 </span>
//               }
//               name="contract"
//               valuePropName="fileList"
//               getValueFromEvent={(e) => e.fileList}
//             >
//               <div className="flex flex-col gap-3">
//                 <div
//                   className="grid grid-cols-[auto,1fr] gap-4 items-start"
//                 >
//                   <Upload
//                     listType="picture-card"
//                     showUploadList={false}
//                     multiple
//                     fileList={fileListContract}   // ✅ controlled by state
//                     onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
//                       const rawFiles = info.fileList
//                         .map((f) => f.originFileObj)
//                         .filter((f): f is RcFile => !!f);

//                       setContract(rawFiles);
//                       setFileListContract(info.fileList);
//                     }}
//                     beforeUpload={() => false}
//                   >
//                     <Button icon={<UploadOutlined />}>Upload</Button>
//                   </Upload>

//                   <div className="grid grid-cols-1 gap-3">
//                     {Contract.map((doc, index) => {
//                       if (!doc) return null;

//                       const fileName =
//                         typeof doc === "string"
//                           ? doc.split("/").pop() || ""
//                           : (doc as File).name;

//                       const fileUrl =
//                         typeof doc === "string"
//                           ? `${imageUrl}${doc}`
//                           : URL.createObjectURL(doc as File);

//                       return (
//                         <div
//                           key={index}
//                           className="flex items-center justify-between border border-gray-200 rounded-lg p-2 bg-white shadow-sm"
//                         >
//                           <div className="flex items-center gap-2 overflow-hidden">
//                             {getFileIcon(fileName)}
//                             <a
//                               href={fileUrl}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="text-sm font-medium truncate max-w-[250px] hover:underline"
//                             >
//                               {fileName}
//                             </a>
//                           </div>

//                           <button
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               handleDeleteContract(doc, index);
//                             }}
//                             className="text-red-500 hover:text-red-700"
//                           >
//                             <DeleteOutlined />
//                           </button>

//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             </Form.Item>

//           </Col>

//         </div>
//         <Col
//           xs={24}
//           sm={24}
//           md={24}
//           xl={24}
//           xxl={20}
//           className="d-flex justify-content-end me-2 mt-2  ml-40"
//         >
//           <div className="button-wrapper">
//             <button
//               className="allcanclebutton"
//               onClick={onClose}
//               disabled={isLoading}
//             >
//               Cancel
//             </button>
//             <button className="allsubmitebutton" disabled={isLoading}>
//               {isLoading ? "Add..." : "Add"}
//             </button>
//           </div>
//         </Col>

//       </Form>
//     </Modal>

//   );
// };

// export default AddProjectModal;

import React, { useContext, useEffect, useState } from "react";
import {
  PlusOutlined,
  MinusCircleOutlined,
  ArrowLeftOutlined,
  DeleteOutlined,
  UploadOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileImageOutlined,
  FileUnknownOutlined,
} from "@ant-design/icons";
import {
  Col,
  Row,
  Form,
  Input,
  message,
  Card,
  Select,
  DatePicker,
  Button,
  Modal,
  Upload,
} from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { BiSolidInbox, BiUpload } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { AuthContext } from "../../Auth/AuthContext";
import {
  addProject,
  getallDeveloperForTask,
  getCustomers,
  getCustomersForReceipts,
  getQualifiedRawData,
} from "../../utils/API";
import { FaUpload } from "react-icons/fa";
import { UploadChangeParam } from "antd/es/upload";
import { UploadFile } from "antd/lib";
import { RcFile } from "antd/lib/upload";
const { Option } = Select;

interface AddProjectModalProps {
  visible: boolean;
  onClose: () => void;
  onTaskCreated: () => void;
  isOpen?: boolean; // Make it optional if you still want to keep it
}
const AddProjectModal: React.FC<AddProjectModalProps> = ({
  visible,
  onClose,
  onTaskCreated,
}) => {
  const navigate = useNavigate();
  const { authData } = useContext(AuthContext);
  const [previewImage, setPreviewImage] = useState<string>("");
  const [apiImageUploaded, setApiImageUploaded] = useState(false);
  const [form] = Form.useForm(); // Use Form hook to get form instance
  const [isLoading, setIsLoading] = React.useState(false);
  const [clients, setClients] = useState<any>([]);
  const user_id = authData.user._id;
  const id = user_id.replace(/["']/g, "");
  const imageUrl = process.env.REACT_APP_IMAGE_URL || "";
  const roleId = authData.roleId;
  const [Purposal, setPurposal] = useState<Array<string | File>>([]);
  const [fileListPurposal, setFileListPurposal] = useState<any[]>([]);
  const [Contract, setContract] = useState<(string | File)[]>([]);
  const [fileListContract, setFileListContract] = useState<UploadFile<File>[]>(
    [],
  );
  const [developers, setDevelopers] = useState<
    { _id: string; username: string }[]
  >([]);
  const [qualifiedLeads, setQualifiedLeads] = useState<any[]>([]);
  const [isTitlesLoading, setIsTitlesLoading] = useState(false);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);

      const formData = new FormData();

      // Append normal fields only if they have a value
      Object.keys(values).forEach((key) => {
        if (
          key !== "purposal" &&
          key !== "contract" &&
          key !== "milestones" &&
          values[key] !== undefined &&
          values[key] !== null &&
          values[key] !== ""
        ) {
          // Special case: budget → send as number if provided
          if (key === "budget") {
            formData.append("budget", String(Number(values.budget)));
          }
          // Special case: assignees → MUST send as array
          else if (key === "assignees") {
            const list = Array.isArray(values.assignees)
              ? values.assignees
              : String(values.assignees)
                  .split(",")
                  .map((id) => id.trim());

            list.forEach((id: string | Blob) =>
              formData.append("assignees[]", id),
            );
          } else {
            formData.append(key, values[key]);
          }
        }
      });

      // Append milestones as JSON string if exists
      if (values.milestones && values.milestones.length > 0) {
        formData.append("milestones", JSON.stringify(values.milestones));
      }

      // Append Purposal files from state
      Purposal.forEach((file) => {
        if (file instanceof File) {
          formData.append("purposal", file as RcFile);
        } else {
          formData.append("purposalExisting", String(file));
        }
      });

      // Append Contract files from state
      Contract.forEach((file) => {
        if (file instanceof File) {
          formData.append("contract", file as RcFile);
        } else {
          formData.append("contractExisting", String(file));
        }
      });

      await addProject(formData);
      message.success("Project added successfully!");
      form.resetFields();
      setPurposal([]);
      setContract([]);
      setFileListPurposal([]);
      setFileListContract([]);
      onTaskCreated();
      onClose();
    } catch (error: any) {
      message.error(error.message || "Failed to add project");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchDevelopers = async () => {
      try {
        const response: any = await getallDeveloperForTask("", "");
        setDevelopers(response?.data || []);
      } catch {
        message.error("Failed to load developers");
        setDevelopers([]);
      }
    };

    fetchDevelopers();
  }, []);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response: any = await getCustomersForReceipts("", "", true);

        if (response?.data) {
          // Filter only active clients
          const activeClients = response.data.filter(
            (client: any) => client.isActive === true,
          );
          setClients(activeClients);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchClients();
  }, []);

  useEffect(() => {
    const fetchQualifiedLeads = async () => {
      if (!visible) {
        return;
      }

      try {
        setIsTitlesLoading(true);
        const response: any = await getQualifiedRawData();
        const leads = Array.isArray(response?.data) ? response.data : [];
        const uniqueLeads = leads.reduce((acc: any[], lead: any) => {
          const normalizedTitle =
            typeof lead?.title === "string" ? lead.title.trim() : "";

          if (
            normalizedTitle &&
            !acc.some(
              (item) =>
                item.title.toLowerCase() === normalizedTitle.toLowerCase(),
            )
          ) {
            acc.push({
              ...lead,
              title: normalizedTitle,
            });
          }

          return acc;
        }, []);

        setQualifiedLeads(uniqueLeads);
      } catch (error) {
        console.error("Error fetching qualified leads:", error);
        setQualifiedLeads([]);
      } finally {
        setIsTitlesLoading(false);
      }
    };

    fetchQualifiedLeads();
  }, [visible]);

  const handleTitleSelect = (_value: string, option: any) => {
    const selectedClient = option?.data;

    if (!selectedClient) {
      return;
    }

    // Auto-fill Client Name and Project Name
    // Auto-fill Client Name ONLY
    form.setFieldsValue({
      clientId: selectedClient._id,
    });

    // Attempt to pull in files if this customer originally came from a Lead
    const normalizedClientName = (selectedClient.name || "")
      .trim()
      .toLowerCase();
    const matchingLead = normalizedClientName
      ? qualifiedLeads.find((lead: any) => {
          const leadClient =
            typeof lead?.clientName === "string"
              ? lead.clientName.trim().toLowerCase()
              : "";
          const leadContact =
            typeof lead?.contactName === "string"
              ? lead.contactName.trim().toLowerCase()
              : "";
          const leadCompany =
            typeof lead?.company === "string"
              ? lead.company.trim().toLowerCase()
              : "";

          return (
            leadClient === normalizedClientName ||
            leadContact === normalizedClientName ||
            leadCompany === normalizedClientName
          );
        })
      : undefined;

    const leadPurposal =
      matchingLead && Array.isArray(matchingLead.purposal)
        ? matchingLead.purposal.filter(Boolean)
        : [];
    const leadContract =
      matchingLead && Array.isArray(matchingLead.contract)
        ? matchingLead.contract.filter(Boolean)
        : [];

    setPurposal(leadPurposal);
    setContract(leadContract);
    setFileListPurposal(
      leadPurposal.map((fileName: string, index: number) => ({
        uid: `rawdata-purposal-${index}-${fileName}`,
        name: fileName.split("/").pop() || fileName,
        status: "done",
        url: `${imageUrl}/rawdata/${fileName}`,
      })),
    );
    setFileListContract(
      leadContract.map((fileName: string, index: number) => ({
        uid: `rawdata-contract-${index}-${fileName}`,
        name: fileName.split("/").pop() || fileName,
        status: "done",
        url: `${imageUrl}/rawdata/${fileName}`,
      })),
    );
  };

  const getFileIcon = (fileName: string) => {
    const ext = fileName.split(".").pop()?.toLowerCase();

    if (ext === "pdf")
      return <FilePdfOutlined className="text-2xl text-red-500 mb-1" />;
    if (ext === "doc" || ext === "docx")
      return <FileWordOutlined className="text-2xl text-blue-500 mb-1" />;
    if (ext === "jpg" || ext === "jpeg" || ext === "png")
      return <FileImageOutlined className="text-2xl text-green-500 mb-1" />;

    // default fallback
    return <FileUnknownOutlined className="text-2xl text-gray-500 mb-1" />;
  };
  const handleDeletePurposal = (doc: string | File, index: number) => {
    const newPurposal = [...Purposal];
    newPurposal.splice(index, 1);
    setPurposal(newPurposal);

    const newFileListPurposal = [...fileListPurposal];
    newFileListPurposal.splice(index, 1);
    setFileListPurposal(newFileListPurposal);
  };

  const handleDeleteContract = (doc: string | File, index: number) => {
    const newContract = [...Contract];
    newContract.splice(index, 1);
    setContract(newContract);

    const newFileListContract = [...fileListContract];
    newFileListContract.splice(index, 1);
    setFileListContract(newFileListContract);
  };

  useEffect(() => {
    if (!visible) {
      form.resetFields();
      setPurposal([]);
      setContract([]);
      setFileListPurposal([]);
      setFileListContract([]);
    }
  }, [visible, form]);

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      centered // Disable centered to use top positioning
      destroyOnClose
      className="custom-modal project-form-modal"
      bodyStyle={{
        maxHeight: "calc(100vh - 64px)",
        overflowX: "hidden",
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Create New Project
        </div>
      }
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
        colon={false}
        initialValues={{
          budget: 0,
        }}
        onFinish={handleSubmit}
      >
        <div className="elements">
          {/* name */}

          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563",
                  fontFamily: "inter, sans-serif",
                  fontWeight: 500,
                  paddingLeft: "15px",
                }}
              >
                Title
              </span>
            }
          >
            <Select
              size="large"
              allowClear
              showSearch
              disabled={roleId == 2}
              loading={isTitlesLoading}
              placeholder="Select Title"
              className="CustomSelect"
              options={clients.map((client: any) => ({
                label: client.name || client.companyName,
                value: client._id,
                data: client,
              }))}
              onChange={handleTitleSelect}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>

          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563",
                  fontFamily: "inter, sans-serif",
                  fontWeight: 500,
                  paddingLeft: "15px",
                }}
              >
                Project Name <span className="text-danger">*</span>
              </span>
            }
            name="projectName"
            required={false}
            rules={[{ required: true, message: "Please Enter Name" }]}
          >
            <Input
              size="large"
              disabled={roleId == 2}
              className="Allinput"
              placeholder="Project Name"
            />
          </Form.Item>

          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563",
                  fontFamily: "inter, sans-serif",
                  fontWeight: 500,
                  paddingLeft: "15px",
                }}
              >
                Client Name<span className="text-danger">*</span>
              </span>
            }
            name="clientId"
            required={false}
            rules={[{ required: true, message: "Please Select Client" }]}
          >
            <Select
              size="large"
              disabled={roleId === 2}
              loading={isLoading}
              placeholder="Select Client"
              className="CustomSelect"
            >
              {clients.map((client: any) => (
                <Select.Option key={client._id} value={client._id}>
                  {client.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563", // Medium gray color similar to the image
                  fontFamily: "inter, sans-serif", // Matches the clean sans-serif style
                  fontSize: "14px", // Approximate font size based on the image
                  fontWeight: 500, // Medium weight to match "font-medium"
                  paddingLeft: "15px",
                }}
              >
                Assignees
              </span>
            }
            required={false}
            name="assignees"
            rules={[
              {
                required: true,
                message: "Please select at least one assignee",
              },
            ]}
          >
            <Select
              mode="multiple"
              placeholder="Select Assignees"
              filterOption={(input, option) =>
                (option?.children ?? "")
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {developers.map((dev) => (
                <Option key={dev._id} value={dev._id}>
                  {dev.username}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563",
                  fontFamily: "inter, sans-serif",
                  fontWeight: 500,
                  paddingLeft: "15px",
                }}
              >
                Start Date<span className="text-danger">*</span>
              </span>
            }
            name="startDate"
            required={false}
            rules={[{ required: true, message: "Please Select Start Date" }]}
          >
            <DatePicker
              size="large"
              disabled={roleId == 2}
              format="DD-MM-YYYY"
              placeholder="Select Start Date"
              className="Allinput"
            />
          </Form.Item>

          {/* Completion Date */}
          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563", // Medium gray color similar to the image
                  fontFamily: "inter, sans-serif", // Matches the clean sans-serif style
                  fontSize: "14px", // Approximate font size based on the image
                  fontWeight: 500, // Medium weight to match "font-medium"
                  paddingLeft: "15px",
                }}
              >
                Target Date <span className="text-danger">*</span>
              </span>
            }
            required={false}
            name="completionDate"
            rules={[{ required: true, message: "Please Select Target Date" }]}
          >
            <DatePicker
              size="large"
              disabled={roleId == 2}
              className="Allinput"
              placeholder="Select Target Date"
              format="DD-MM-YYYY"
            />
          </Form.Item>

          {/* Ending Date */}

          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563", // Medium gray color similar to the image
                  fontFamily: "inter, sans-serif", // Matches the clean sans-serif style
                  fontSize: "14px", // Approximate font size based on the image
                  fontWeight: 500, // Medium weight to match "font-medium"
                  paddingLeft: "15px",
                }}
              >
                Complete Date
              </span>
            }
            name="endingDate"
            required={false}
          >
            <DatePicker
              size="large"
              disabled={roleId == 2}
              className="Allinput"
              placeholder="Select Complete Date"
              format="DD-MM-YYYY"
            />
          </Form.Item>

          {/* budget*/}

          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563",
                  fontFamily: "inter, sans-serif",
                  fontWeight: 500,
                  paddingLeft: "15px",
                }}
              >
                Budget
              </span>
            }
            name="budget"
            initialValue={0}
          >
            <Input
              type="number"
              size="large"
              className="Allinput"
              placeholder="Budget"
              // defaultValue={0}
            />
          </Form.Item>

          {/* Milestone */}
          <Form.Item
            label={
              <span
                style={{
                  color: "#4b5563",
                  fontFamily: "inter, sans-serif",
                  fontWeight: 500,
                  paddingLeft: "15px",
                }}
              >
                Milestones
              </span>
            }
            colon={false}
          >
            <Form.List name="milestones">
              {(fields, { add, remove }) => (
                <div className="milestone-wrapper">
                  {/* Add Milestone Button at the Top */}
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    className="w-100 mb-3"
                  >
                    Add Milestone
                  </Button>

                  {/* Milestone Cards - rendered in reverse order */}
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div
                      key={key}
                      className="subtask-card"
                      style={{ order: -index }}
                    >
                      <div className="row project-milestone-row">
                        {/* Milestone Date */}
                        <div className="column project-milestone-column">
                          <Form.Item
                            {...restField}
                            name={[name, "date"]}
                            rules={[
                              {
                                required: true,
                                message: "Please select a date",
                              },
                            ]}
                          >
                            <DatePicker
                              size="large"
                              disabled={roleId == 2}
                              className="subtask-input"
                              format="DD-MM-YYYY"
                              placeholder="Select Milestone Date"
                            />
                          </Form.Item>
                        </div>

                        {/* Milestone Comment */}
                        <div className="column project-milestone-column">
                          <Form.Item
                            {...restField}
                            name={[name, "comment"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter a comment",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              disabled={roleId == 2}
                              className="subtask-input"
                              placeholder="Enter Milestone Comment"
                            />
                          </Form.Item>
                        </div>
                      </div>

                      {/* Remove Button */}
                      <div className="delete-btn-container">
                        <Button
                          danger
                          type="text"
                          icon={<DeleteOutlined />}
                          onClick={() => remove(name)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Form.List>
          </Form.Item>
          <Col span={24}>
            <Form.Item
              label={
                <span
                  style={{
                    color: "#4b5563",
                    fontFamily: "inter, sans-serif",
                    fontSize: "14px",
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}
                >
                  Proposal
                </span>
              }
              name="purposal"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <div className="flex flex-col gap-3">
                <div className="project-upload-layout grid grid-cols-[auto,minmax(0,1fr)] items-start gap-4">
                  <Upload
                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    listType="picture-card"
                    // maxCount={1}
                    showUploadList={false}
                    // disabled={Purposal.length > 0} // Disable when file exists
                    fileList={fileListPurposal} // ✅ controlled by state
                    onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
                      const rawFiles = info.fileList
                        .map((f) => f.originFileObj)
                        .filter((f): f is RcFile => !!f);

                      setPurposal(rawFiles);
                      setFileListPurposal(info.fileList);
                    }}
                    beforeUpload={() => false}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      // disabled={resumes.length > 0} // Visual disabled state
                    >
                      Upload
                    </Button>
                  </Upload>

                  <div className="grid min-w-0 grid-cols-1 gap-3">
                    {Purposal.map((doc, index) => {
                      if (!doc) return null;

                      const fileName =
                        typeof doc === "string"
                          ? doc.split("/").pop() || ""
                          : (doc as File).name;

                      const fileUrl =
                        typeof doc === "string"
                          ? `${imageUrl}/rawdata/${doc}`
                          : URL.createObjectURL(doc as File);

                      return (
                        <div
                          key={index}
                          className="flex min-w-0 items-center justify-between gap-2 rounded-lg border border-gray-200 bg-white p-2 shadow-sm"
                        >
                          <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
                            {getFileIcon(fileName)}
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="max-w-full truncate text-sm font-medium hover:underline"
                            >
                              {fileName}
                            </a>
                          </div>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDeletePurposal(doc, index);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            <DeleteOutlined />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={
                <span
                  style={{
                    color: "#4b5563",
                    fontFamily: "inter, sans-serif",
                    fontSize: "14px",
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}
                >
                  NDA/Contract
                </span>
              }
              name="contract"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <div className="flex flex-col gap-3">
                <div className="project-upload-layout grid grid-cols-[auto,minmax(0,1fr)] items-start gap-4">
                  <Upload
                    listType="picture-card"
                    showUploadList={false}
                    multiple
                    fileList={fileListContract} // ✅ controlled by state
                    onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
                      const rawFiles = info.fileList
                        .map((f) => f.originFileObj)
                        .filter((f): f is RcFile => !!f);

                      setContract(rawFiles);
                      setFileListContract(info.fileList);
                    }}
                    beforeUpload={() => false}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>

                  <div className="grid min-w-0 grid-cols-1 gap-3">
                    {Contract.map((doc, index) => {
                      if (!doc) return null;

                      const fileName =
                        typeof doc === "string"
                          ? doc.split("/").pop() || ""
                          : (doc as File).name;

                      const fileUrl =
                        typeof doc === "string"
                          ? `${imageUrl}/rawdata/${doc}`
                          : URL.createObjectURL(doc as File);

                      return (
                        <div
                          key={index}
                          className="flex min-w-0 items-center justify-between gap-2 rounded-lg border border-gray-200 bg-white p-2 shadow-sm"
                        >
                          <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
                            {getFileIcon(fileName)}
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="max-w-full truncate text-sm font-medium hover:underline"
                            >
                              {fileName}
                            </a>
                          </div>

                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDeleteContract(doc, index);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            <DeleteOutlined />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Form.Item>
          </Col>
        </div>
        <Col
          xs={24}
          style={{
            position: "sticky",
            bottom: 0,
            background: "#fff",
            borderTop: "1px solid #f1f5f9",
            padding: "12px 16px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            zIndex: 10,
          }}
        >
          <button
            className="allcanclebutton"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button className="allsubmitebutton" disabled={isLoading}>
            {isLoading ? "Adding..." : "Add"}
          </button>
        </Col>
      </Form>
    </Modal>
  );
};

export default AddProjectModal;
